<template>
  <div class="orderCenter-right">
    <div class="head">
      <h3>试用商品订单</h3>
    </div>
    <div class="main">
      <Tables :list="this.mailList"></Tables>
      <div class="person-tag__list-pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageIndex"
            :page-sizes="[5,10, 20, 30]"
            background
            layout="total, sizes , prev, pager, next"
            :total="total"
          >
      </el-pagination>
    </div>
    </div>
  </div>
</template>

<script>
import Tables from "./table";
export default {
  data() {
    return {
      mailList: [], //总数据list
      pageIndex: 1,
      pageSize: 10,
      total: 0,
    };
  },
  components: {
    Tables,
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.dataListFn();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.dataListFn();
    },
    handleChange(value) {},
    dataListFn() {
      this.$api.tryApply.applyList({
        page:this.pageIndex,
        limit:this.pageSize
      }).then((res) => {
        this.mailList = res.data;
        this.total = res.count;
      })
    }
  },
  created() {
    this.dataListFn();
  }
};
</script>

<style lang="less" scoped>
*{
font-size: 14px;
}
.orderCenter-right {
  width: 876px;
  .head {
    h3 {
      height: 31px;
      font-size: 24px;
      color: #333333;
    }
  }
  .main {
    margin-top: 26px;
  }
}

  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #A52A2A !important;
  }
  /deep/.person-tag__list-pagination {
    text-align: center;
    margin-top: 20px;
    span{
      font-weight: 600;
    }
  }
</style>